import React from 'react';

import { Footer } from '../../containers';
import { Navbar, Email} from '../../components';
import './e-learning.css';

const eLearning = () => {
  return (
    <div className="eLearning">
        <div className="gradient__bg">
          <Navbar />
        </div>
        <Email />
        <Footer />
    </div>
  )
}

export default eLearning